import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultAssignmentSkip } from '@pxtra-client-lib-legacy/gen';
import { ConfirmationDialogWithWarnings } from '../../../../lib/components';

const MAX_LISTED_SKIPS = 8;

type Props = {
  skipped: DefaultAssignmentSkip[];
  onClose: () => void;
};

export const SkippedDefaultsDialog: FC<Props> = ({ skipped, onClose }) => {
  const { t } = useTranslation();

  const entries = skipped.slice(0, MAX_LISTED_SKIPS).map((skip) =>
    t('company:APPLY_DEFAULTS_SKIPPED_ENTRY', {
      employeeName: skip.employee_name,
      field: t('company:APPLY_DEFAULTS_SKIPPED_FIELD', { context: skip.field }),
      reason: skip.reason
    })
  );

  const remaining = skipped.length - entries.length;
  const warnings = [
    t('company:APPLY_DEFAULTS_SKIPPED', { count: skipped.length }),
    ...entries,
    remaining > 0 ? t('company:APPLY_DEFAULTS_SKIPPED_MORE', { count: remaining }) : undefined
  ];

  return (
    <ConfirmationDialogWithWarnings
      open={skipped.length > 0}
      width="520px"
      title={t('company:APPLY_DEFAULTS_SKIPPED_TITLE')}
      warnings={warnings}
      confirmButtonText={t('company:APPLY_DEFAULTS_SKIPPED_CONFIRM')}
      hideCancelButton
      onConfirm={onClose}
      onClose={onClose}
    />
  );
};
